import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {ExamService} from '../../../../services/exam/exam.service';
import {DomSanitizer} from '@angular/platform-browser';
import {CommonModule} from "@angular/common";

@Component({
  selector: 'app-third-reading',
  standalone: true,
  imports: [
    CommonModule
  ],
  templateUrl: './third-reading.component.html',
  styleUrls: ['./third-reading.component.scss']
})
export class ThirdReadingComponent implements OnInit, OnDestroy {

  @Input() idLevel: string;
  @Output() eventEmitter = new EventEmitter<string>();
  questions: any[] = [];

  answers: { [key: string]: string | undefined } = {};
  letters: string[] = ['A', 'B', 'C', 'D', 'E', 'F'];
  constructor(
    private examSrv: ExamService,
    private domSanitizer: DomSanitizer
  ) { }

  trackByIndex(index: number) { return index; }

  async ngOnInit(): Promise<void> {
    // Generate questions
    this.questions = await this.examSrv.generate(this.idLevel, 'THIRD_READING');
    this.questions.forEach((item) => {
      item.questions.forEach((question) => {
        this.answers[question.uniqid] = undefined;
      });
    });
  }

  selectAnswer(question, answer): void {
    this.answers[question.uniqid] = answer.uniqid;
  }

  isSelected(question, answer): boolean {
    return this.answers[question.uniqid] === answer.uniqid;
  }

  isAnswered(question): boolean {
    return this.answers[question.uniqid] !== undefined;
  }

  getIndex(i: number, j: number): number {
    let index = 0;

    for (let k = 0; k < i; k++) {
      index += this.questions[k].questions.length;
    }

    return index + j + 1;
  }

  transform(html: string) {
    return this.domSanitizer.bypassSecurityTrustHtml(html);
  }

  next(): void {
    this.eventEmitter.emit('THIRD_READING');
  }

  async ngOnDestroy(): Promise<void> {
    await this.examSrv.submit(this.idLevel, {
      answers: this.answers,
      type: 'THIRD_READING'
    });
  }
}
